import { Box, Button, Typography } from '@mui/material';
import FontAwesomeSvgIcon from 'components/shared/FontAwesomeSvgIcon';
import { t } from 'i18next';
import {
  faChevronDown,
  faChevronUp
} from 'vendors/@fortawesome/pro-light-svg-icons';
import useGetFlexRequestHistory from '../hooks/useGetFlexRequestHistory';
import dayjs from 'dayjs';
import { GridColDef } from '@mui/x-data-grid-pro';
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

const FlexRequestHistoryTable = ({
  processInstanceId,
  setShowTaskHistory,
  showTaskHistory
}) => {
  const { data: rows, isFetching: isFetchingRows } =
    useGetFlexRequestHistory(processInstanceId);

  const columns: GridColDef[] = [
    {
      field: 'taskDefinitionKey',
      headerName: t('flexHistory.taskHistory.taskName'),
      flex: 1,
      valueGetter: (params) =>
        t(`flexHistory.taskHistory.taskNames.${params.row.taskDefinitionKey}`, {
          defaultValue: params.row.taskDefinitionKey
        })
    },
    {
      field: 'assignee',
      headerName: t('flexHistory.taskHistory.assignee'),
      width: 150
    },
    {
      field: 'performedAction',
      headerName: t('flexHistory.taskHistory.reply'),
      width: 100,
      valueGetter: (params) =>
        params.row.performedAction &&
        t(`flexHistory.taskHistory.replies.${params.row.performedAction}`, {
          defaultValue: params.row.performedAction
        })
    },
    {
      field: 'startTime',
      headerName: t('flexHistory.taskHistory.start'),
      width: 160,
      valueGetter: (params) =>
        dayjs(params.row.startTime).format('D MMMM YYYY HH:mm')
    },
    {
      field: 'endTime',
      headerName: t('flexHistory.taskHistory.end'),
      width: 160,
      valueGetter: (params) =>
        dayjs(params.row.endTime).format('D MMMM YYYY HH:mm')
    }
  ];

  return isFetchingRows ? (
    <>Loading...</>
  ) : (
    <Box mb={1}>
      <Button
        onClick={() => {
          setShowTaskHistory(!showTaskHistory);
        }}
        color="dark"
        size="small"
        variant="text"
        sx={{ display: 'flex', gap: 1, textTransform: 'none', mb: 0.5 }}
      >
        <Typography variant="h4" component="h4" sx={{ fontSize: '16px' }}>
          {t('flexHistory.taskHistory.title')}
        </Typography>
        {showTaskHistory ? (
          <>
            <FontAwesomeSvgIcon
              icon={faChevronUp}
              fontSize="inherit"
              color="inherit"
            />
          </>
        ) : (
          <>
            <FontAwesomeSvgIcon
              icon={faChevronDown}
              fontSize="inherit"
              color="inherit"
            />
          </>
        )}
      </Button>
      {showTaskHistory && (
        <TableCRUDLayout
          rows={rows || []}
          getRowId={(row) => row.id}
          shouldRenderToolBar={true}
          columns={columns}
          autoHeight={true}
          pageSize={5}
          disableSelectionOnClick
          hideFooter={rows && rows?.length < 5}
          disableActions={true}
        />
      )}
    </Box>
  );
};

export default FlexRequestHistoryTable;
